import axios from "axios"
import { env } from "../constants"

export const get = token => {
    const uri = `${env.startpoint}me`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const update = (token, data) => {
    const uri = `${env.startpoint}me`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.patch(uri, data, headers).then(response => response).catch(error => error.response)
}

export const avatar = (token, file) => {
    const uri = `${env.startpoint}me/avatar`
    const form = new FormData()
    form.append("file", file)
    const headers = { headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" } }
    return axios.post(uri, form, headers).then(response => response).catch(error => error.response)
}

export const removeAvatar = token => {
    const uri = `${env.startpoint}me/avatar`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}

export const remove = token => {
    const uri = `${env.startpoint}me`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}

export const reviews = token => {
    const uri = `${env.startpoint}me/reviews`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const pendingReviews = token => {
    const uri = `${env.startpoint}me/reviews/pending`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const repeatBookings = token => {
    const uri = `${env.startpoint}me/bookings/repeat`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}
